import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramInsurersAddPage } from './program-insurers-add';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramInsurersAddPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramInsurersAddPage),
    MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule
  ],
})
export class ProgramInsurersAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-insurers-add/program-insurers-add.module.ts